import apiBase from "../../../api/axios";

export const getPreguntasConfirmacionPlantelService = async (
  plantelId,
  page = 1,
  search = "",
) => {
  let url = `v1/talentos-plantel/preguntas-confirmacion/?page=${page}&plantel=${plantelId}`;
  if (search) {
    url += `&search=${encodeURIComponent(search)}`;
  }
  const response = await apiBase.get(url);
  return response.data;
};

export const getPreguntaConfirmacionPlantelByIdService = async (id) => {
  const response = await apiBase.get(
    `v1/talentos-plantel/preguntas-confirmacion/${id}/`,
  );
  return response.data;
};

export const updatePreguntaConfirmacionPlantelService = async (id, payload) => {
  const response = await apiBase.put(
    `v1/talentos-plantel/preguntas-confirmacion/${id}/`,
    payload,
  );
  return response.data;
};

export const togglePreguntaConfirmacionPlantelActiveService = async (id) => {
  const response = await apiBase.patch(
    `v1/talentos-plantel/preguntas-confirmacion/${id}/toggle-status/`,
  );
  return response.data;
};
